// extracted by mini-css-extract-plugin
export default {"errorContainer":"ContactInfoError_errorContainer__M9ca7"};